export default "__VITE_ASSET__a7588245__"